import { DesignMenuState, DesignTabs } from './DesignMenu.types'
import { useCurrentPage } from '@dtx-company/inter-app/src/redux/slices/utils/currentPage'
import { useState } from 'react'

export function useDesignMenuState(): DesignMenuState {
  const [curTab, setTab] = useState(DesignTabs.COLOR)
  const page = useCurrentPage()
  return { curTab, setTab, pageTheme: page?.theme }
}
